<!--
 * @Description: 顶部条右边用户信息
-->
<template>
  <div class="nav-right">
    <!-- 如果打开这个就会报错 ElOnlyChild No valid child node -->
    <!-- <el-popover
      placement="bottom-end"
      :width="340"
      trigger="hover"
      :popper-options="popOpt"
      popper-class="enterprise-manage-popper"
    > -->
    <!--:visible="true" 来调试-->
    <!-- <div class="enterprise-manage-wrap">
        <div class="enterprise-manage-top">
          <div class="company-info">
            <span class="company-name">用户角色、用户名啥的</span>
          </div>
        </div>
      </div>
    </el-popover> -->

    <div class="user-name">
      <svg-icon name="home-user-head" class-name="head-img"></svg-icon>
      <span class="name">{{ display_name }}</span>
      <span @click="handleLogout"> 退出登录</span>
    </div>

    <!-- <el-dropdown trigger="click" :popper-options="popOpt">
      <div class="user-name">
        <svg-icon name="home-user-head" class-name="head-img"></svg-icon>
        <span class="name">{{ userInfo.name }}</span>
      </div>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item>
            <span @click="accountInformation">
              <svg-icon name="account" class-name="user-icon"></svg-icon>账号信息</span
            >
          </el-dropdown-item>
          <el-dropdown-item>
            <span @click="handleLogout">
              <svg-icon name="logout" class-name="user-icon"></svg-icon>退出登录</span
            >
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown> -->
  </div>
</template>

<script lang="ts">
export default {
  name: 'CompHeaderUser'
}
</script>

<script lang="ts" setup>
import useUserStore from '../../../stores/user_stores'
import { storeToRefs } from 'pinia'
import { removeToken } from '../../../utils/cookie_storage'

import { ElMessageBox } from 'element-plus'
import router from '../../../router'

const userStore = useUserStore()

const { display_name } = storeToRefs(userStore)

function handleLogout() {
  ElMessageBox.confirm('你确定要退出系统吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(async () => {
    userStore.setUserInfo({})
    removeToken()
    // 跳转到登录界面
    router.replace('/login')
  })
}

</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

@mixin opacityMixin {
  cursor: pointer;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
}
.nav-right {
  //min-width: 520px;
  color: #fff;
  padding-right: 35px;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .nav-user-item {
    margin-right: 35px;
    cursor: pointer;
    height: 64px;
    line-height: 64px;

    &:hover {
      color: $color-primary;
    }
    &.is-active {
      color: $color-primary;
      height: 64px;
      border-bottom: 3px solid #00cd96;
    }
  }

  .nav-user-item a {
    color: #fff;
  }

  .certification-box {
    width: 50px;
    height: 20px;
    font-size: 12px;
    line-height: 20px;
    background: #505866;
    color: #ffffff;
    text-align: center;
    border-radius: 2px;
    margin-right: 12px;

    &.active {
      background: #e6890e;
    }
  }

  .company-info {
    @include opacityMixin;

    .el-icon-sort {
      margin-left: 10px;
      transform: rotateZ(90deg);
      font-size: 16px;
    }
  }

  .line {
    height: 16px;
    background: #e3e3e3;
    opacity: 0.3;
    width: 1px;
    margin: 0 36px 0 35px;
  }
}

.user-name {
  color: #fff;
  height: 64px;
  line-height: 64px;
  font-size: 14px;
  @include opacityMixin;
  display: flex;
  align-items: center;
  outline: none;

  .head-img {
    width: 30px;
    height: 30px;
    margin-right: 6px;
  }

  .name {
    margin-right: 12px;
    display: inline-block;
    vertical-align: middle;
    max-width: 128px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: right;
  }
}

.user-icon {
  width: 18px;
  height: 18px;
  vertical-align: middle;
  margin-right: 12px;
  color: #fff;
}
</style>
